import axios from "axios";
import xlsx from "json-as-xlsx";

const UITextSummaryColumns = {
  "es-CL": {
    xlsxName: "Reporte de escaneo",
    summarySheetName: "Escaneo de dispositivos",
    userCol: "Usuario",
    deviceCol: "Dispositivo",
    detailsID: "Hoja de detalles #",
    startTime: "Inicio de escaneo",
    endTime: "Fin de escaneo",
    scanStatus: "Scan status",
    errorMessage: "Mensaje de error",
    scanCompleted: "Escaneo completado",
  },
  "en-US": {
    summarySheetName: "Device scan",
    userCol: "User",
    deviceCol: "Device",
    detailsID: "Details sheet #",
    startTime: "Scan start time",
    endTime: "Scan end time",
    scanStatus: "Scan status",
    errorMessage: "Error message",
    scanCompleted: "Scan completed",
  },
};

const UITextDetailsColumns = {
  "es-CL": {
    scanErrorID: "ID de Escaneo",
    errorID: "ID de error",
    errorMessage: "Mensaje de error",
    repositoryID: "ID de repositorio",
    resourceID: "ID de recurso",
    errorType: "Tipo de error",
  },
  "en-US": {
    scanErrorID: "Scan ID",
    errorID: "Error ID",
    errorMessage: "Error message",
    repositoryID: "Repository ID",
    resourceID: "Resource ID",
    errorType: "Error type",
  },
};

const microsoft365driveServiceId = 1;

const generateC365ScanReport = (data) => {
  const { M365server, cloner_key, scans, locale } = data;
  const sCols = UITextSummaryColumns[locale];
  const dCols = UITextDetailsColumns[locale];
  const summaryColumns = [
    { label: sCols.userCol, value: "cloner_user" }, // Top level data
    { label: sCols.deviceCol, value: "device" }, // Top level data
    { label: sCols.detailsID, value: "detailsID" }, // Top level data
    { label: sCols.startTime, value: "init_time" }, // Top level data
    { label: sCols.endTime, value: "end_time" }, // Top level data
    { label: sCols.scanStatus, value: "status" }, // Top level data
    { label: sCols.errorMessage, value: "error_messagestatus" }, // Top level data
    { label: sCols.scanCompleted, value: "complete_scan" }, // Top level data
  ];
  const dColumns = [
    { label: dCols.scanErrorID, value: "Error_id" }, // Top level data
    { label: dCols.errorID, value: "id" }, // Top level data
    { label: dCols.errorMessage, value: "message" }, // Top level data
    { label: dCols.repositoryID, value: "repo_id" }, // Top level data
    { label: dCols.resourceID, value: "resource" }, // Top level data
    { label: dCols.errorType, value: "type_error" }, // Top level data
    ];

  return async (dispatch) => {
    let xlsxData = [
      {
        sheet: sCols.summarySheetName,
        columns: summaryColumns,
        content: [],
      },
    ];
    let ct = 0;
    for (const item of scans) {
      try {
        const url = new URL("mailapi/scan/status", M365server);
        //   const url = M365server + "mailapi/scan/status";

        const params = new URLSearchParams({
          cloner_user: item.user,
          service_id: microsoft365driveServiceId,
        });
        url.search = params.toString();

        //   const bodyData = JSON.stringify(item);

        const response = await axios.get(url.toString(), {
          headers: { cloner_key },
        });

        console.log("resp data: ", response.data);

        let d = response.data;
        let dataPoint = d.data[0];

        ct++

        dataPoint.device = item.device;
        dataPoint.detailsID = ct;

        xlsxData[0].content.push(dataPoint);

        console.log("Data: ", dataPoint.ErrorDB);


        xlsxData.push({
            sheet: `${ct}`,
            columns: dColumns,
            content: dataPoint.ErrorDB??[],
        })

        // let xlsxData = [
        //   {
        //     sheet: sCols.summarySheetName,
        //     columns: summaryColumns,
        //     content: d.data,
        //   },
        //   // {
        //   //   sheet: text.sheet2,
        //   //   columns,
        //   //   content: onlySelected,
        //   // },
        // ];
      } catch (e) {
        console.error(e);
        //   dispatch(workerActions.finish({ id: c365ScanErrorsId, error: e.msg }));
        //   enqueueSnackbar(error, { variant: "error" });
      }
    }

    let settings = {
      fileName: sCols.xlsxName, // Name of the resulting spreadsheet
      extraLength: 3, // A bigger number means that columns will be wider
      // writeMode: "writeFile", // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
      // writeOptions: {}, // Style options from https://docs.sheetjs.com/docs/api/write-options
      // RTL: true, // Display the columns from right-to-left (the default value is false)
    };

    console.log("xlsxData: ", xlsxData);

    xlsx(xlsxData, settings); // Will download the excel file
  };
};

export default generateC365ScanReport;
